import { render } from "./ClientActions.vue?vue&type=template&id=631b0c64&scoped=true"
import script from "./ClientActions.vue?vue&type=script&lang=js"
export * from "./ClientActions.vue?vue&type=script&lang=js"

import "./ClientActions.vue?vue&type=style&index=0&id=631b0c64&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631b0c64"]])

export default __exports__